<ui-dialog [isCloseable]="false" [open]="openDialog" header="applicant-tracker.changeFunnelStage">
    <p>{{ { key: 'applicant-tracker.email-will-send-to-applicant', params: { subject } } | appTranslate }}</p>
    <p>{{ 'applicant-tracker.are-you-sure-you-want-to-send-email' | appTranslate }}</p>
    <ui-dialog-footer>
        <ui-button type="ghost" (click)="onClose()">{{ 'applicant-tracker.skip-email' | appTranslate }}</ui-button>
        <ui-button type="primary" (click)="onConfirm()">{{ 'applicant-tracker.send-email' | appTranslate }}</ui-button>
    </ui-dialog-footer>
</ui-dialog>
